<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="todo__filters-container">
    <!-- all -->
    <div class="px-6 py-4">
      <router-link
        tag="span"
        class="flex cursor-pointer"
        :class="{ 'text-primary': todoFilter == 'all' }"
        :to="`${baseUrl}/all`"
        @click.native="getCategoryData('all')"
      >
        <feather-icon
          icon="LayersIcon"
          :svgClasses="[
            { 'text-primary stroke-current': todoFilter == 'all' },
            'h-6 w-6',
          ]"
        ></feather-icon>

        <span class="text-lg ml-3">All</span>
      </router-link>
    </div>

    <vs-divider></vs-divider>

    <!-- starred -->
    <div class="px-6 py-4">
      <h5>Filters</h5>
      <div class="swap-icon">
        <vs-icon
          icon="swap_vert"
          @click="swapEnable"
          style="font-size: 24px"
          class="p-2 mr-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
          :class="{
            'text-primary stroke-current': is_swap_enable == true,
          }"
        />
      </div>
      <draggable
        class="cursor-move"
        :list="categories"
        @change="changeCategoryPosition"
        :draggable="is_swap_enable == true ? '.filter-item-div' : ''"
      >
        <template v-for="(filter, index) in categories">
          <div :key="index" class="filter-item-div todo__lables-list" style="">
            <div class="hamburger-icon">
              <vs-icon
                icon="menu"
                v-if="is_swap_enable"
                style="font-size: 24px"
                class="p-2"
              />
            </div>
            <router-link
              v-if="filter.is_edit == false"
              tag="div"
              class="todo__label flex items-center mt-6 cursor-pointer filter-item"
              :class="{ 'text-primary': todoFilter == filter.category }"
              :to="`${baseUrl}/${filter.category}`"
              @click.native="getCategoryData(filter.category)"
            >
              <vx-tooltip
                :text="filter.status_published ? 'Published' : 'Unpublished'"
                position="bottom"
                delay=".3s"
              >
                <div
                  class="ml-1 h-3 w-3 rounded-full mr-2"
                  :class="{
                    'gray-color': filter.status_published == false,
                    'purple-color': filter.status_published == true,
                  }"
                />
              </vx-tooltip>
              <feather-icon
                :icon="filter.icon"
                :svgClasses="[
                  { 'text-primary stroke-current': todoFilter == filter },
                  'h-6 w-6',
                ]"
              ></feather-icon>
              <span class="text-lg ml-3">{{ filter.category }}</span>
              <feather-icon
                @click.stop="editCategory(index, filter)"
                icon="EditIcon"
                class="hide h-6 w-6 ml-5"
              ></feather-icon>
            </router-link>
            <div v-if="filter.is_edit" class="input-icon-div">
              <vx-tooltip
                :text="status_published ? 'Published' : 'Unpublished'"
                position="bottom"
                delay=".3s"
              >
                <vs-switch v-model="status_published" class="mt-2 mr-1">
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vx-tooltip>

              <vs-input
                name="Category name"
                placeholder="Category name"
                class="w-full pt-3"
                v-model="category_name"
              />
              <feather-icon
                @click.stop="clickAccept(index)"
                icon="CheckSquareIcon"
                class="h-6 w-6 ml-1"
              ></feather-icon>
              <feather-icon
                @click.stop="clickClose(index)"
                icon="XSquareIcon"
                class="h-6 w-6 ml-1"
              ></feather-icon>
            </div>
          </div>
        </template>
      </draggable>
    </div>

    <vs-divider></vs-divider>

    <!-- <div class="px-6 py-4">
      <h5>Labels</h5>
      <div class="todo__lables-list">
        <router-link
          tag="span"
          class="todo__label flex items-center mt-6 cursor-pointer"
          v-for="(tag, index) in taskTags"
          :key="index"
          :to="`${baseUrl}/${tag.value}`"
        >
          <div
            class="ml-1 h-3 w-3 rounded-full mr-4"
            :class="'border-2 border-solid border-' + tag.color"
          />
          <span
            class="text-lg"
            :class="{ 'text-primary': todoFilter == tag.value }"
            >{{ tag.text }}</span
          >
        </router-link>
      </div>
    </div> -->
  </div>
</template>

<script>
import DataProvider from "../../../services/data-provider";
import draggable from "vuedraggable";

export default {
  props: {
    categories: {
      type: Array,
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      is_swap_enable: false,
      category_name: "",
      old_category_name: "",
      old_status_published_value: true,
      status_published: true,
      todoFilters: [
        { filterName: "Allergy", filter: "allergy", icon: "StarIcon" },
        { filterName: "Asthma", filter: "asthma", icon: "InfoIcon" },
        // { filterName: 'Completed', filter: 'completed', icon: 'CheckIcon' },
        // { filterName: 'Trashed', filter: 'trashed', icon: 'TrashIcon' }
      ],
    };
  },
  computed: {
    taskTags() {
      // console.log("Task data:",this.$store.state.todo.taskTags);
      // return this.$store.state.todo.taskTags;
      let tasks = [
        { color: "primary", id: 5, text: "Primary", value: "frontend" },
        { color: "warning", id: 5, text: "Company", value: "frontend" },
        { color: "success", id: 5, text: "Important", value: "frontend" },
        { color: "danger", id: 5, text: "Private", value: "frontend" },
      ];
      return tasks;
    },
    todoFilter() {
      return this.$route.params.filter;
    },
    baseUrl() {
      const path = this.$route.path;
      return path.slice(0, path.lastIndexOf("/"));
    },
  },
  methods: {
    swapEnable() {
      console.log("swapEnable");
      this.is_swap_enable = !this.is_swap_enable;
    },
    changeCategoryPosition(event) {
      console.log(event);
      this.$vs.loading();
      console.log(this.categories);
      let old_category;
      let new_category;
      let new_id;
      let old_id;
      if (event.moved.newIndex == 0) {
        new_category = this.categories[event.moved.newIndex].category
          .split(" ")
          .join("_");
        old_category = this.categories[event.moved.newIndex + 1].category
          .split(" ")
          .join("_");
        old_id = this.categories[event.moved.newIndex + 1].collection_order;
        new_id = this.categories[event.moved.newIndex].collection_order;
        console.log("new::", this.categories[event.moved.newIndex]);
        console.log("old::", this.categories[event.moved.newIndex + 1]);
      } else {
        new_category = this.categories[event.moved.newIndex].category
          .split(" ")
          .join("_");
        old_category = this.categories[event.moved.newIndex - 1].category
          .split(" ")
          .join("_");
        old_id = this.categories[event.moved.newIndex - 1].collection_order;
        new_id = this.categories[event.moved.newIndex].collection_order;
        console.log("new::", this.categories[event.moved.newIndex]);
        console.log("old::", this.categories[event.moved.newIndex - 1]);
      }
      // } else {
      //   category2 = this.categories[event.moved.newIndex + 1].category
      //     .split(" ")
      //     .join("_");
      //     old_id=event.moved.newIndex +1
      // }

      console.log(new_category, old_category, new_id, old_id);
      DataProvider.setCollectionOrder(
        new_category,
        old_category,
        new_id,
        old_id
      ).then(
        (res) => {
          console.log(res);
          this.$emit("reload_categories");
          this.$vs.loading.close();
        },
        (err) => {
          this.$vs.loading.close();
        }
      );
    },
    getCategoryData(filter_name) {
      console.log("getCategoryData");
      // this.$vs.loading();
      this.is_swap_enable = false;
      this.$emit("reoad_all_category");
      this.$emit("reload_category_data", filter_name);
    },
    editCategory(index, category_item) {
      console.log("editCategory", category_item);
      this.setIsEditFalse();
      this.category_name = category_item.category;
      this.old_category_name = category_item.category;
      this.status_published = category_item.status_published;
      this.old_status_published_value = category_item.status_published;
      this.categories[index].is_edit = true;
    },
    clickAccept(index) {
      console.log("clickAccept");

      const old_category_name = this.old_category_name.split(" ").join("_");
      const category_name = this.category_name.split(" ").join("_");
      console.log(this.status_published);
      if (
        old_category_name.toLowerCase().split(" ").join("") !=
        category_name.toLowerCase().split(" ").join("")
      ) {
        this.$vs.loading();
        DataProvider.updateCategoryName(
          old_category_name.toLowerCase().split(" ").join(""),
          category_name.toLowerCase().split(" ").join(""),
          this.category_name.toLowerCase()
        ).then(
          (data) => {
            if (this.old_status_published_value != this.status_published) {
              DataProvider.updateCategoryMetaData(
                category_name.toLowerCase().split(" ").join(""),
                this.status_published
              ).then(
                (res) => {
                  console.log("updateCategoryMetaData res", res);
                },
                (err) => {
                  console.log("updateCategoryMetaData error:", err);
                }
              );
            }
            console.log("success data:", data);
            DataProvider.deleteOldCategory(old_category_name).then(
              (data) => {
                console.log("deleteOldCategory call");
                this.$vs.loading.close();
                this.clearFieldValue(index);
                this.$emit("reload_categories");
              },
              (err) => {
                this.$vs.loading.close();
                console.log("Error", err);
                this.clearFieldValue(index);
              }
            );
          },
          (err) => {
            this.$vs.loading.close();
            console.log("Error !!", err);
            this.clearFieldValue(index);
          }
        );
      } else {
        if (this.old_status_published_value != this.status_published) {
          this.$vs.loading();
          DataProvider.updateCategoryMetaData(
            category_name.toLowerCase().split(" ").join(""),
            this.status_published
          ).then(
            (res) => {
              console.log("updateCategoryMetaData res", res);
              this.$vs.loading.close();
              this.$emit("reload_categories");
            },
            (err) => {
              console.log("updateCategoryMetaData error:", err);
              this.$vs.loading.close();
              this.clearFieldValue(index);
            }
          );
        } else {
          this.clearFieldValue(index);
        }
      }
    },
    clearFieldValue(index) {
      this.category_name = "";
      this.old_category_name = "";
      this.categories[index].is_edit = false;
    },
    clickClose(index) {
      console.log("clickClose");
      this.category_name = "";
      this.old_category_name = "";
      this.categories[index].is_edit = false;
    },
    setIsEditFalse() {
      this.categories.filter((itm, i) => {
        this.categories[i].is_edit = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.filter-item span {
  text-transform: capitalize;
}
.hide {
  display: none;
  z-index: 99;
}
.purple-color {
  // background-color: #7367f0;
  background-color: green;
}
.gray-color {
  background-color: #e2e2e2;
}

.filter-item:hover .hide {
  display: block !important;
}
.input-icon-div {
  display: flex;
  align-items: center;
  .feather-icon {
    cursor: pointer;
    margin-top: 5px;
  }
}
.swap-icon {
  position: absolute;
  right: 0;
  top: 138px;
}
.hamburger-icon {
  position: absolute;
  right: 13px;
  margin-top: -8px;
}
</style>

